import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ubs-card-list',
  templateUrl: './card-mode.component.html',
  styleUrls: ['./card-mode.component.scss']
})
export class CardModeComponent implements OnInit {
  @Input() settings:any;
  @Input() source:any;
  hasItems:boolean = false;
  items:any[];

  constructor() { }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["settings"]){
      setTimeout(()=>{ 
        this.createItems(this.settings);
      }, 600);
      
    }
  }

  createItems(settings){
    let items = []
    //console.log({CardModeComponent:{Settings:this.settings,Source:this.source}});
    this.source.data.forEach(row => {
      let fields = [];
      Object.entries(row).forEach(([key,value]) => {
        let field = {};
        field["name"]=key;
        field["value"]=value;
        field["column"]= settings["columns"][key];
        fields.push(field);
      })
      //console.log({Fields:fields});
      let item = {fields:fields};
      items.push(item);
    })
    if(items.length > 0){
      this.hasItems = true;
    }
    this.items = items;

  }

}
